import {
    getQuoteForm,
    getSelectedCoverOption,
    getComparisonData,
    getSelectedPlanIndexComparison,
    getQuote,
    getPremiumCalculation,
    getPageName,
} from '../../../selectors/afyaImara/quote';
import { getPersonalDetailsForm, getSelectedForm } from '../../../selectors/afyaImara/personalDetails';
import { getSpouseDetailsForm } from '../../../selectors/afyaImara/spouseDetails';
import { getChildDetailsForms } from '../../../selectors/afyaImara/childDetails';
import { getDocumentsForm } from '../../../selectors/afyaImara/documents';
import { getNextOfKinForm } from '../../../selectors/afyaImara/nextOfKin';
import { getIsApiPending, getPayloadCollection } from '../../../selectors/afyaImara/payloadCollection';
import { getMedicalHistoryData } from '../../../selectors/afyaImara/medicalHistory';
import {
    apiTransitionPayloadCollection,
    submitPayloadDataSuccess,
    submitPayloadDataFailure,
    collectId,
} from '../../../actions/afyaImara/payloadCollection';

//import { getAgentForm } from '../../../selectors/ugMotorInsurance/travelAgentModal';
import {
    getAccessToken,
    getPaymentStatusData,
    getPaymentsForm,
    getModeOfPayments,
} from '../../../selectors/afyaImara/payments';
import axios from 'axios';
import { triggerConfirmOrder } from '../../../actions/afyaImara/payments';
import { apiTransitionAfyaImaraInsuranceQuotePayloadCollectionForm } from '../../../actions/afyaImara/quote';
import {
    apiTransitionPersonalDetailsForm,
    setPersonalDetailsIdValue,
} from '../../../actions/afyaImara/personalDetails';
import { apiTransitionMedicalHistoryForm } from '../../../actions/afyaImara/medicalHistory';

export function getAgeFromDateString(dateString) {
    // Split the date string into day, month, and year components
    if (!dateString) {
        return null;
    }

    const [day, month, year] = dateString.split('/').map(Number);

    // Create a Date object for the date of birth
    const birthDate = new Date(year, month - 1, day); // Month is 0-indexed in JavaScript Date

    // Get the current date
    const today = new Date();

    // Calculate the age
    let age = today.getFullYear() - birthDate.getFullYear();

    // Adjust age if the current date is before the birthdate in the current year
    const currentMonth = today.getMonth();
    const birthMonth = birthDate.getMonth();
    if (currentMonth < birthMonth || (currentMonth === birthMonth && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}

export const payloadSubmitService = (store, next, action) => {
    const pageName = getPageName(store.getState());

    (async () => {
        // if (!getIsApiPending(store.getState())) {
        if (pageName === 'quote') {
            store.dispatch(apiTransitionAfyaImaraInsuranceQuotePayloadCollectionForm.pending());
        } else if (pageName === 'livesCovered') {
            store.dispatch(apiTransitionPersonalDetailsForm.pending());
        } else if (pageName === 'medicalHistory') {
            store.dispatch(apiTransitionMedicalHistoryForm.pending());
        } else {
            store.dispatch(apiTransitionPayloadCollection.pending());
        }
        try {
            const resp = await makeSubmission(store.getState());

            store.dispatch(submitPayloadDataSuccess(resp.data));
            if (pageName === 'quote') {
                store.dispatch(collectId(resp.data.id));
                store.dispatch(apiTransitionAfyaImaraInsuranceQuotePayloadCollectionForm.success());
            } else if (pageName === 'livesCovered') {
                store.dispatch(setPersonalDetailsIdValue(resp.data.id));
                store.dispatch(apiTransitionPersonalDetailsForm.success());
            } else if (pageName === 'medicalHistory') {
                store.dispatch(apiTransitionMedicalHistoryForm.success());
            } else {
                store.dispatch(apiTransitionPayloadCollection.success());
            }
            // store.dispatch(triggerConfirmOrder());
        } catch (e) {
            console.error(e);
            store.dispatch(submitPayloadDataFailure(e));
            if (pageName === 'quote') {
                store.dispatch(apiTransitionAfyaImaraInsuranceQuotePayloadCollectionForm.failure());
            } else if (pageName === 'livesCovered') {
                store.dispatch(apiTransitionPersonalDetailsForm.failure());
            } else if (pageName === 'medicalHistory') {
                store.dispatch(apiTransitionMedicalHistoryForm.failure());
            } else {
                store.dispatch(apiTransitionPayloadCollection.failure());
            }
        }
        // }
    })();
    return next(action);
};

const createDependants = (spouseIncluded, spouseDetails, childrenIncluded, childDetails, documents) => {
    const dependants = [];
    if (spouseIncluded === 'yes') {
        dependants.push({
            fullName: `${spouseDetails.firstName.value}`,
            gender: 'N/A',
            relationship: 'Partner',
            dateOfBirth: `${spouseDetails.dob.value}`,
            profession: 'N/A',
            idDoc: documents?.spouseId?.value?.base64File || 'N/A',
        });
    }

    if (childrenIncluded === 'yes') {
        childDetails?.map((child) => {
            dependants.push({
                fullName: child.firstName?.value || 'N/A',
                gender: 'N/A',
                relationship: 'Child',
                dateOfBirth: `${child.dob?.value}` || 'N/A',
                profession: 'N/A',
                birthCertificate: child?.birthCertificate?.value?.base64File || 'N/A',
            });
        });
    }

    return dependants;
};

const payloadCollection = (state) => {
    // Get the data to be returned from state
    const quotation = getQuoteForm(state);
    const quote = getQuote(state);
    const pageName = getPageName(state);
    const documents = getDocumentsForm(state);
    const principalId = getPayloadCollection(state).id;
    const selectedForm = getSelectedForm(state);

    // Quotation payload
    const quotationPayload = {
        countryCode: 'KE',
        step: 'productQuote',
        fullName: quotation?.fullName?.value || '',
        email: quotation?.email?.value || '',
        phoneNumber: quotation?.phoneNumber?.value || '',
        productId: parseInt(quote?.productId) || 0,
        age: getAgeFromDateString(quotation?.dob?.value) || 0,
        inPatient: {
            inpatientLimitId: quotation?.inpatientCover?.value || 0,
        },
        outPatient: {
            present: !!quotation?.outpatientCover?.value,
            outpatientLimitId: quotation?.outpatientCover?.value ? quotation?.outpatientCover?.value.toString() : '0',
            option:
                quote?.productId === '2' || quote.productId === '3' || quote?.productId === '6'
                    ? '2'
                    : quotation?.outpatientCover?.value
                    ? quotation?.outpatientCoverOption?.value !== 'per family per annum'
                        ? '2'
                        : '1'
                    : '1',
        },
        familyMembers: {
            children: {
                count: quotation?.childrenDobs?.value?.length || 0,
            },
            spouse: {
                age: getAgeFromDateString(quotation?.spouseDob?.value) || 0,
            },
        },
        omRescuePlus: quotation?.omRescuePlus?.value || false,
    };

    // Personal details payload
    const personalDetails = getPersonalDetailsForm(state);
    const personalDetailsPayload = {
        firstName: personalDetails?.firstName?.value || 'N/A',
        lastName: 'NA',
        IdNumber: personalDetails?.idNumber?.value || 'N/A',
        pin: personalDetails?.tinNumber?.value || 'N/A',
        NhifNumber: personalDetails?.nihfNumber?.value || 'N/A',
        dateOfBirth: personalDetails?.dob?.value || 'N/A',
        phoneNumber: personalDetails?.phoneNumber?.value || 'N/A',
        emailAddress: personalDetails?.email?.value || 'N/A',
        streetAddress: personalDetails?.streetAddress?.value || 'N/A',
        surbub: personalDetails?.suburb?.value || 'N/A',
        city: personalDetails?.city?.value || 'N/A',
        postalCode: personalDetails?.postalCode?.value || 'NA',
        postalAddress: personalDetails?.postalAddress?.value || 'N/A',
        gender: personalDetails?.gender?.value || 'N/A',
        maritalStatus: personalDetails?.maritalStatus?.value || 'N/A',
        idDoc: documents?.idUpload?.value?.base64File || 'N/A',
        kraPinDoc: documents?.kraPinUpload?.value?.base64File || 'N/A',
    };

    // Lives covered payload
    const spouseDetails = getSpouseDetailsForm(state);
    const childDetails = getChildDetailsForms(state);
    const livesCovered = createDependants(
        quotation.spouseIncluded.value,
        spouseDetails,
        quotation.childrenIncluded.value,
        childDetails,
        documents
    );

    // Next of kin payload
    const nextOfKin = getNextOfKinForm(state);
    const nextOfKinPayload = {
        firstName: nextOfKin?.firstName?.value || '',
        lastName: nextOfKin?.lastName?.value || '',
        IdNumber: nextOfKin?.idNumber?.value || '',
        relationship: nextOfKin?.relationship?.value || '',
        emailAddress: nextOfKin?.email?.value || '',
        postalAddress: nextOfKin?.postalAddress?.value || '',
    };

    const principalDetailsPayload = {
        step: 'principalDetails',
        quoteId: principalId,
        ...personalDetailsPayload,
        utmSource: 'oldmutual',
    };

    const livesCoveredPayload = {
        step: 'livesCovered',
        principalId,
        ...personalDetailsPayload,
        livesCovered: livesCovered || [],
        nextOfKin: nextOfKinPayload,
    };

    // Documents payload

    // Payment payload
    const paymentsForm = getPaymentsForm(state);
    const modeOfPayment = getModeOfPayments(state);
    const paymentsData = getPaymentStatusData(state);
    const comparisonData = getComparisonData(state);
    const premimCalculation = getPremiumCalculation(state);
    const premium = premimCalculation?.premium;
    const paymentPayload = {
        step: 'payment',
        principalId,
        paidAmount: premium || 0,
        transactionReference: paymentsData?.CheckoutRequestID || 'N/A',
        transactionStatus: paymentsData?.status || '200',
        modeOfPayment: modeOfPayment?.value || 'MPESA',
    };

    // Chronical diseases payload
    const medicalHistory = getMedicalHistoryData(state);
    const cronicalDiseasesPayload = {
        step: 'medicalHistory',
        principalId,
        cronicalDiseases: medicalHistory || [],
    };

    // Return merged payload
    if (pageName === 'quote') {
        return quotationPayload;
    } else if (pageName === 'livesCovered') {
        if (selectedForm === 'documentDetails') return principalDetailsPayload;
        return livesCoveredPayload;
    } else if (pageName === 'medicalHistory') {
        return cronicalDiseasesPayload;
    } else {
        return paymentPayload;
    }
};

const makeSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-afya-imara/submit-payload';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
